<div class="search-container">
	<!-- OpenSearch Text Search Section -->
	<div class="text-search-section">
		<small class="section-description">Search across all documents</small>
		<!--(independent of dates)-->

		<div class="search-term-field">
			<label for="search-term">Search term</label>
			<div class="search-input-group">
				<input
					pInputText
					id="search-term"
					type="text"
					[value]="searchTerm()"
					(input)="onSearchTermChange($any($event.target).value)"
					(keydown.enter)="onTextSearch()"
					placeholder="Enter search term..."
					class="search-input"
					data-testid="search-term-input"
				/>
				<p-button
					icon="pi pi-search"
					ariaLabel="Search"
					pTooltip="Search documents"
					(onClick)="onTextSearch()"
					class="search-button"
					[disabled]="!hasEnvironment() || !searchTerm().trim()"
					data-testid="search-submit-button"
				/>
			</div>
			<small class="search-example">Example: 'Gadget', 'Error: timeout', etc.</small>
		</div>
	</div>
</div>
